import React from "react";
import PropTypes from "prop-types";
import "react-dropdown/style.css";
import Pagination from "react-js-pagination";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import Layout from "containers/Layout";
import ThemMoiNhanVien from "components/CommonComponent/ThemMoiNhanVien";
import { PhanQuyenNhom } from "components/CommonComponent/PhanQuyenNhom";
import LayoutV2 from "containers/LayoutV2";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";
import { ShowNhanVien } from "./ThemMoiNhanVien";
import { pushNotification } from "utils/notifications";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ModalKhoa } from "./ChucNang/ModalKhoa";
import { ModalMoKhoa } from "./ChucNang/ModalMoKhoa";
import { PhanQuyenUser } from "components/CommonComponent/PhanQuyenUser";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import { ShowTaiKhoanReset } from "./ThemMoiTaiKhoanReset";
import { ModalDuyetTatToan } from "./ChucNang/ModalDuyetTatToan";
class DanhSachNhanVien extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      showPhanQuyenNhom: false,
      showPhanQuyenUser: false,
      showTaiKhoanReset: false,
      showDuyetTatToan: false,
      showKhoa: false,
      showMoKhoa: false,
      isModalXoa: false,
      dataSearch: {
        sSearch: "",
        cuaHang: "",
        trangThai: "-1",
        pageIndex: 1,
        pageSize: 20,
      },
      dataDanhSach: [],
      danhSachCuaHang: [],
      TotalQuantity: 0,
      listRoles: [],
      nhanvien: {},
    };
  }

  componentDidMount() {
    this.onSearch();
    this.loadCuaHang();
  }

  loadDanhSachNhanVien(dataSearch) {
    let { getListDanhSachNhanVien } = this.props;
    getListDanhSachNhanVien(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  setModalThemMoiNhanVienShow = () => {
    this.setState({
      nhanvien: null,
      showEdit: !this.state.showEdit,
    });
  };

  setModalPhanQuyenNhomShow = () => {
    this.setState({
      showPhanQuyenNhom: !this.state.showPhanQuyenNhom,
    });
  };

  loadCuaHang = async () => {
    try {
      let data = {
        sCode: "",
        sName: "",
        sAddress: "",
        sPhone: "",
        sStatus: "",
        pageIndex: 1,
        pageSize: 20,
        trangThai: "-1",
      };
      const res = await DanhSachCuaHangApi.list(data);
      // setdataResponse(res.data || []);
      var lstUser = res.data.List.map((item) => ({
        value: item.CompanyID,
        label: item.Name,
      }));

      lstUser.unshift({
        value: "",
        label: "Tất cả",
      });

      this.setState({
        danhSachCuaHang: lstUser,
      });
    } catch (error) {
      console.error("Lỗi load danh sách cửa hàng:", error);
    } finally {
    }
  };

  setModalPhanQuyenUserShow = (item) => {
    this.setState({
      nhanvien: item,
      showPhanQuyenUser: !this.state.showPhanQuyenUser,
    });
  };

  setModalUserReset = (item) => {
    this.setState({
      nhanvien: item,
      showTaiKhoanReset: !this.state.showTaiKhoanReset,
    });
  };

  setModalDuyetTatToan = (item) => {
    this.setState({
      nhanvien: item,
      showDuyetTatToan: !this.state.showDuyetTatToan,
    });
  };

  onChangeData = (field, event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.onSearch();
    }
  };

  handlePageChange = (PageIndex) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = PageIndex;
    this.setState({ dataSearch });
    this.onSearch();
  };

  setModalKhoaShow = () => {
    this.setState({
      showKhoa: !this.state.showKhoa,
    });
  };

  setModalMoKhoaShow = () => {
    this.setState({
      showMoKhoa: !this.state.showMoKhoa,
    });
  };

  setModalKhoa = (item) => {
    this.setState({
      nhanvien: item,
      showKhoa: !this.state.showKhoa,
    });
    this.setModalKhoaShow();
  };

  setModalMoKhoa = (item) => {
    this.setState({
      nhanvien: item,
      showMoKhoa: !this.state.showMoKhoa,
    });
    this.setModalMoKhoaShow();
  };

  setModalEdit = (item) => {
    console.log("itemitemitem", item);
    if (item) {
      this.setState({
        nhanvien: item,
        showEdit: !this.state.showEdit,
      });
    }
  };

  toggleModalXoa = () => {
    this.setState({
      isModalXoa: !this.state.isModalXoa,
    });
    console.log("this.state.isModalXoa", this.state.isModalXoa);
  };

  deleteItem = (item) => {
    this.setState({
      nhanvien: item,
    });
    this.toggleModalXoa();
  };

  onSearch = () => {
    let { dataSearch } = this.state;
    console.log("dataSearch", dataSearch);
    DanhSachNhanVienApi.list({
      search: dataSearch.sSearch,
      cuaHang: dataSearch.cuaHang,
      trangThai: dataSearch.trangThai,
      pageIndex: dataSearch.pageIndex ?? 1,
      pageSize: dataSearch.pageSize,
    }).then((response) => {
      if (response.status == "200") {
        this.setState({
          dataDanhSach: response.data.List || [],
          TotalQuantity: response.data.TotalQuantity || 0,
          listRoles: response.data.Roles || [],
        });
      }
    });
  };

  handleChangeRole = (item, newRoleId) => {
    const { dataDanhSach } = this.state;

    // Cập nhật quyền cho nhân viên tương ứng
    const updatedList = dataDanhSach.map((nv) => {
      if (nv.Email === item.Email) {
        return { ...nv, Role: newRoleId };
      }
      return nv;
    });

    this.setState({ dataDanhSach: updatedList });
  };

  luuQuyenNhanVien = (item) => {
    console.log("userNameuserName", item);
    DanhSachNhanVienApi.luuQuyenNhanVien(item).then((response) => {
      if (response.data.Error == 0) {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
        this.onSearch();
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    });
  };

  renderTableRows() {
    let { dataDanhSach, dataSearch, listRoles } = this.state;
    console.log("dataDanhSach", dataDanhSach);
    return dataDanhSach.map((item, index) => (
      <div class="custom-table-row active">
        <div class="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
          <span class="mobile-column-name">STT</span>
          <div class="center-wrapper">
            <p class="text-center">
              {(dataSearch.pageIndex - 1) * dataSearch.pageSize + index + 1}
            </p>
          </div>
        </div>
        <div class="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span class="mobile-column-name">Tên đăng nhập</span>
          <div class="center-wrapper">
            <p class="text-left">{item.TenDangNhap}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span class="mobile-column-name">Email đăng nhập</span>
          <div class="center-wrapper">
            <p class="text-left">{item.Email}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span class="mobile-column-name">Tên nhân viên</span>
          <div class="center-wrapper">
            <p class="text-left"> {item.HoTen}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span class="mobile-column-name">Điện thoại</span>
          <div class="center-wrapper">
            <p class="text-center"> {item.SDT}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-20 flex-basis-20-sm">
          <span class="mobile-column-name">Cửa hàng</span>
          <div class="center-wrapper">
            <p class="text-left">{item.CuaHang}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-10 flex-basis-10-sm">
          <span class="mobile-column-name">Quyền</span>
          <div class="center-wrapper">
            {item.Role == "shopadmin" && (
              <p class="text-center">
                {" "}
                <select class="selectBox form-control input-sm" disabled>
                  <option value="shopuser">Chủ</option>
                </select>
              </p>
            )}
            {item.Role !== "shopadmin" && (
              <p class="text-center">
                <select
                  class="selectBox form-control input-sm"
                  value={
                    item.Role || (listRoles.length > 0 ? listRoles[0].ID : "")
                  }
                  onChange={(e) => this.handleChangeRole(item, e.target.value)} // nếu cần xử lý khi đổi quyền
                >
                  {listRoles.map((item, idx) => (
                    <option key={"combo" + idx} value={item.ID}>
                      {item.Values}
                    </option>
                  ))}
                </select>
              </p>
            )}
          </div>
        </div>

        <div class="custom-table-cell flex-basis-15 flex-basis-15-sm  action-cell">
          <div class="center-wrapper">
            <div class="iconTableMormanCenter">
              {/* Nút Lưu ghi đè quyền cá nhân bằng quyền nhóm (UpdateQuyenUserName).
                  Tài khoản chủ không đổi được quyền nên nút này chỉ gây nhầm lẫn. */}
              {item.Role !== "shopadmin" && (
                <a
                  href={() => false}
                  onClick={(e) => this.luuQuyenNhanVien(item)}
                >
                  <PopoversBootrap
                    contentText="Lưu"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i class="mdi mdi-content-save"></i>
                  </PopoversBootrap>
                </a>
              )}
              <a href={() => false} onClick={(e) => this.setModalEdit(item)}>
                <PopoversBootrap
                  contentText="Sửa"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-button-edit-v2.png" />
                </PopoversBootrap>
              </a>
              <a
                href={() => false}
                onClick={(e) => this.setModalPhanQuyenUserShow(item)}
              >
                <PopoversBootrap
                  contentText="Phân quyền"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i class="mdi mdi-account-cog"></i>
                </PopoversBootrap>
              </a>
              {!item.IsLocked && (
                <a href={() => false} onClick={(e) => this.setModalKhoa(item)}>
                  <PopoversBootrap
                    contentText="Khoá"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <img src="/app-assets/images/icon-khoa-cau-hinh-tai-san.png" />
                  </PopoversBootrap>
                </a>
              )}
              {item.IsLocked && (
                <a
                  href={() => false}
                  onClick={(e) => this.setModalMoKhoa(item)}
                >
                  <PopoversBootrap
                    contentText="Mở khoá"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <img src="/app-assets/images/icon-mo-cau-hinh-tai-san.png" />
                  </PopoversBootrap>
                </a>
              )}
              {item.AllowDelete && (
                <a href={() => false} onClick={(e) => this.deleteItem(item)}>
                  <PopoversBootrap
                    contentText="Xoá"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <img src="/app-assets/images/icon-button-xoa-v2.png" />
                  </PopoversBootrap>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    ));
  }
  render() {
    let {
      dataSearch,
      showEdit,
      isModalXoa,
      isModalKhoa,
      isModalMoKhoa,
      showPhanQuyenNhom,
      showPhanQuyenUser,
      showTaiKhoanReset,
      showDuyetTatToan,
      showKhoa,
      showMoKhoa,
      dataDanhSach,
      TotalQuantity,
    } = this.state;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div class="sticky-moman-bh">
            <div class="col-12">
              <div class="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Danh sách nhân viên
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div
                      className="search-new hidden-mobile-main show-table-main"
                      style={{ marginTop: 5 }}
                    >
                      <div class="input-sm-new input-new-18">
                        <label className="font-color-default font-bold">
                          Tìm kiếm
                        </label>
                        <input
                          type="text"
                          class="form-control input-sm"
                          placeholder="Tìm kiếm"
                          onChange={this.onChangeData.bind(this, "sSearch")}
                          onKeyDown={this.handleKeyDown}
                          value={dataSearch.sSearch}
                        />
                      </div>
                      <div class="input-sm-new input-new-18">
                        <label className="font-color-default font-bold">
                          Cửa hàng
                        </label>
                        <select
                          class="selectBox form-control input-sm"
                          value={this.state.dataSearch.cuaHang}
                          onChange={this.onChangeData.bind(this, "cuaHang")}
                        >
                          {this.state.danhSachCuaHang.map((item, idx) => (
                            <option key={"combo" + idx} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div class="input-sm-new input-new-18">
                        <label className="font-color-default font-bold">
                          Trạng thái
                        </label>
                        <select
                          class="selectBox form-control input-sm"
                          value={this.state.dataSearch.trangThai}
                          onChange={this.onChangeData.bind(this, "trangThai")}
                        >
                          <option value="-1">Tất cả</option>
                          <option value="1">Đang dùng</option>
                          <option value="0">Đã khóa</option>
                        </select>
                      </div>

                      <div class="input-sm-new input-new-18 search-main-new">
                        <button
                          type="submit"
                          className="btn btn-info-new btn-seach-ds"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div data-repeater-item class="">
                      <form class="form row bg-search-form form-mobile-search">
                        <div class="text-right left-search search-p mb-1 ">
                          <div class="search-mobile-new">
                            <fieldset class="form-group position-relative mb-0">
                              <input
                                type="text"
                                class="form-control input-sm"
                                id="iconLeft1"
                                placeholder="Tên, mã, sđt nhân viên ..."
                              />
                              <div class="form-control-position">
                                <i class="mdi mdi-magnify"></i>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                        <div class="mb-1 ">
                          <button
                            type="button"
                            class="btn btn-chuc-nang-v2 mb-1 "
                            onClick={this.setModalThemMoiNhanVienShow}
                          >
                            <i class="mdi mdi-plus"></i> Thêm mới
                          </button>

                          <button
                            type="button"
                            class="btn btn-chuc-nang-v2 mb-1 "
                            onClick={this.setModalUserReset}
                          >
                            <img src="/app-assets/images/icon-tai-khoan-reset-v2.png" />{" "}
                            Thêm tài khoản reset
                          </button>
                          <button
                            type="button"
                            class="btn btn-chuc-nang-v2 mb-1 "
                            onClick={this.setModalPhanQuyenNhomShow}
                          >
                            <i class="fas fa-users-cog"></i> Phân quyền nhóm
                          </button>
                          <button
                            type="button"
                            class="btn btn-chuc-nang-v2 mb-1 "
                            onClick={this.setModalDuyetTatToan}
                          >
                            <i class="mdi mdi-check-decagram"></i> Duyệt tất
                            toán
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div class="mobile-pad hide-table-main show-mobile-main hidden-des-main">
                  <div class="row bg-form-table"></div>
                </div>

                <div className="card border-light mb-1 show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div className="row col-sm-12 col-md-12 themoi-taisanthanhly hidden-mobile-main">
                      <button
                        type="button"
                        class="btn btn-chuc-nang-v2 mb-1 "
                        onClick={this.setModalThemMoiNhanVienShow}
                      >
                        <i class="mdi mdi-plus"></i> Thêm mới
                      </button>

                      <button
                        type="button"
                        class="btn btn-chuc-nang-v2 mb-1 "
                        onClick={this.setModalUserReset}
                      >
                        <i class="fas fa-plus"></i> Thêm tài khoản reset
                      </button>
                      <button
                        type="button"
                        class="btn btn-chuc-nang-v2 mb-1 "
                        onClick={this.setModalPhanQuyenNhomShow}
                      >
                        <i class="fas fa-users-cog"></i> Phân quyền nhóm
                      </button>
                      <button
                        type="button"
                        class="btn btn-chuc-nang-v2 mb-1 "
                        onClick={this.setModalDuyetTatToan}
                      >
                        <i class="mdi mdi-check-decagram"></i> Duyệt tất toán
                      </button>
                    </div>
                    <br />
                    <div class="Left808x200 Table-main-new">
                      <div class="table-mobile ">
                        <div class="custom-table-wrapper">
                          <div class="table-headers">
                            <div class="custom-table-header flex-basis-5 flex-basis-5-sm">
                              <p class="text-center">
                                STT
                                <br />{" "}
                                <span class="color-do-bold">
                                  {this.state.TotalQuantity}
                                </span>
                              </p>
                            </div>
                            <div class="custom-table-header flex-basis-10 flex-basis-10-sm">
                              <p class="text-left">Tên đăng nhập</p>
                            </div>
                            <div class="custom-table-header flex-basis-15 flex-basis-15-sm">
                              <p class="text-left">Email đăng nhập</p>
                            </div>
                            <div class="custom-table-header flex-basis-10 flex-basis-10-sm">
                              <p class="text-left">Tên nhân viên</p>
                            </div>
                            <div class="custom-table-header flex-basis-10 flex-basis-10-sm">
                              <p class="text-center">Điện thoại</p>
                            </div>
                            <div class="custom-table-header flex-basis-20 flex-basis-20-sm">
                              <p class="text-left">Cửa hàng</p>
                            </div>
                            <div class="custom-table-header flex-basis-10 flex-basis-10-sm">
                              <p class="text-left">Quyền</p>
                            </div>
                            <div class="custom-table-header flex-basis-15 flex-basis-15-sm">
                              <p class="tab-header  text-left">Chức năng</p>
                            </div>
                          </div>

                          <div class="custom-table-body">
                            {this.renderTableRows()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div className="row">
                      <div className="col-sm-12  col-md-6">
                        <span className="color7">
                          {TotalQuantity === 0 ? (
                            "Hiển thị 0 - 0 / Tổng số 0"
                          ) : (
                            <>
                              Hiển thị{" "}
                              {(dataSearch.pageIndex - 1) *
                                dataSearch.pageSize +
                                1}{" "}
                              -{" "}
                              {Math.min(
                                dataSearch.pageIndex * dataSearch.pageSize,
                                TotalQuantity,
                              )}{" "}
                              / Tổng số {TotalQuantity}
                            </>
                          )}
                        </span>
                      </div>
                      <div className="col-sm-12  col-md-6">
                        <div
                          className={
                            "paniation-new paniation-new1 d-flex justify-content-center " +
                            (TotalQuantity === 0 ? "hidden" : "")
                          }
                          style={{ float: "right" }}
                        >
                          <nav aria-label="Page navigation">
                            <Pagination
                              activePage={dataSearch.pageIndex}
                              itemsCountPerPage={dataSearch.pageSize}
                              totalItemsCount={TotalQuantity}
                              pageRangeDisplayed={5}
                              onChange={this.handlePageChange}
                              itemClass="page-item border-none"
                              linkClass="page-link border-none"
                              activeClass="active"
                            />
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showEdit && (
          <ShowNhanVien
            data={this.state.nhanvien}
            show={this.state.showEdit}
            onSearch={this.onSearch}
            onHide={this.setModalThemMoiNhanVienShow}
          />
        )}
        {isModalXoa && (
          <ModalXoa
            isModalVisible={this.state.isModalXoa}
            onSearch={this.onSearch}
            toggleModal={this.toggleModalXoa}
            item={this.state.nhanvien}
          />
        )}
        <PhanQuyenNhom
          show={showPhanQuyenNhom}
          onHide={this.setModalPhanQuyenNhomShow}
        ></PhanQuyenNhom>

        <PhanQuyenUser
          item={this.state.nhanvien}
          show={showPhanQuyenUser}
          onHide={this.setModalPhanQuyenUserShow}
        ></PhanQuyenUser>

        {showKhoa && (
          <ModalKhoa
            isModalVisible={this.state.showKhoa}
            onSearch={this.onSearch}
            toggleModal={this.setModalKhoaShow}
            item={this.state.nhanvien}
          ></ModalKhoa>
        )}

        {showMoKhoa && (
          <ModalMoKhoa
            isModalVisible={this.state.showMoKhoa}
            onSearch={this.onSearch}
            toggleModal={this.setModalMoKhoaShow}
            item={this.state.nhanvien}
          ></ModalMoKhoa>
        )}
        {showTaiKhoanReset && (
          <ShowTaiKhoanReset
            data={this.state.nhanvien}
            show={this.state.showTaiKhoanReset}
            onSearch={this.onSearch}
            onHide={this.setModalUserReset}
          ></ShowTaiKhoanReset>
        )}
        {showDuyetTatToan && (
          <ModalDuyetTatToan
            data={this.state.nhanvien}
            show={this.state.showDuyetTatToan}
            onSearch={this.onSearch}
            onHide={this.setModalDuyetTatToan}
          ></ModalDuyetTatToan>
        )}
      </LayoutV2>
    );
  }
}

export default DanhSachNhanVien;
